<template>
  <el-dialog
    v-model="dialogStatus"
    :close-on-click-modal="false"
    @close="close"
    :title="dialogTitle"
    :width="width"
    append-to-body>
    <el-form ref="form" :model="form" :rules="rules" label-width="140px">
      <el-form-item label="广告主RTA" prop="advertiserRtaId">
        <el-select 
          v-model="form.advertiserRtaId" 
          placeholder="请选择广告主RTA" 
          size="medium" 
          filterable 
          style="width: 100%;">
          <el-option
            v-for="item in advertiserRtaList"
            :key="item.id"
            :label="item.rtaName"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="投放任务ID" prop="taskIdList">
        <el-input 
          v-model="form.taskIdList" 
          size="medium" 
          placeholder="多个任务ID用逗号分隔"
          maxlength="500"
          show-word-limit/>
        <div style="color: #999; font-size: 12px; margin-top: 5px;">
          常用于广告主针对单个RTA接口中多个投放任务，多个ID用英文逗号分隔
        </div>
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-radio-group v-model="form.status">
          <el-radio :label="0">禁用</el-radio>
          <el-radio :label="1">启用</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div style="text-align: right;">
      <el-button @click="close" size="medium">取消</el-button>
      <el-button @click="submit" type="primary" size="medium" :loading="submitLoading">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { bindRta, updateRtaBind } from '@/api/ocpx/rtaBind'
import { getEnabledRtaList } from '@/api/ocpx/rta'

export default {
  props: {
    channelRtaId: {
      type: Number,
      required: true
    },
    title: String,
    width: {
      type: Number,
      default: 700
    }
  },
  emits: ['submit'],
  data () {
    return {
      dialogStatus: false,
      submitLoading: false,
      advertiserRtaList: [],
      form: {
        id: undefined,
        channelRtaId: undefined,
        advertiserRtaId: undefined,
        taskIdList: undefined,
        status: 1
      },
      rules: {
        advertiserRtaId: [{ required: true, message: '请选择广告主RTA', trigger: 'change' }],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }]
      }
    }
  },
  computed: {
    dialogTitle () {
      return (this.title ? this.title : '') + (this.form.id ? '编辑' : '新增')
    }
  },
  methods: {
    async show (data) {
      this.dialogStatus = true
      this.form.channelRtaId = this.channelRtaId
      
      // 加载广告主RTA列表
      await this.loadAdvertiserRtaList()
      
      if (data) {
        this.form = Object.assign({}, data)
      }
    },
    close () {
      this.dialogStatus = false
      this.reset()
    },
    submit () {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.form.id) {
            this.doUpdate(this.form)
          } else {
            this.doAdd(this.form)
          }
        }
      })
    },
    doAdd (form) {
      this.submitLoading = true
      bindRta(form).then(res => {
        if (res.code === 200) {
          this.$message.success('新增成功')
          this.$emit('submit')
          this.close()
        }
      }).finally(() => {
        this.submitLoading = false
      })
    },
    doUpdate (form) {
      this.submitLoading = true
      updateRtaBind(form).then(res => {
        if (res.code === 200) {
          this.$message.success('编辑成功')
          this.$emit('submit')
          this.close()
        }
      }).finally(() => {
        this.submitLoading = false
      })
    },
    async loadAdvertiserRtaList () {
      try {
        const res = await getEnabledRtaList()
        if (res.code === 200) {
          this.advertiserRtaList = res.data || []
        }
      } catch (error) {
        console.error('加载广告主RTA列表失败:', error)
      }
    },
    reset () {
      this.form = {
        id: undefined,
        channelRtaId: this.channelRtaId,
        advertiserRtaId: undefined,
        taskIdList: undefined,
        status: 1
      }
      this.$refs.form && this.$refs.form.resetFields()
    }
  }
}
</script>

<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 15px;
}
</style>
